/* ============================================================
   HIT: trilhos (faixas de cards que rolam de lado), as setas e a régua deles, e a posição de cada um guardada por página.
   Portado de projetos/design-propostas/direcao-b/index.html ("Trilhos: marcação, setas, régua, volta à posição" e o
   registro da rolagem). A marcação é de snippets/trilho.liquid (e de HitPecas.trilhoHtml); aqui só o comportamento.

     window.HitTrilhos = { atualizaTrilho, sincronizaTrilhos, restauraTri, rolaSeta, posicao: { le, guarda, esquece } }

   Contrato: um trilho tem [data-rol] (e [data-tri] com o nome dele) e um id. Setas são .setas[data-sd="<id do trilho>"] com dois
   .seta; a régua é o irmão .regua logo depois do trilho (nasce e some com a largura: só existe abaixo de 900px).
   As setas somem se o trilho não rola e ficam aria-disabled nas pontas.

   POSIÇÃO POR PÁGINA. Cada trilho guarda o scrollLeft em sessionStorage, na chave "hit:tri:<caminho>|<data-tri>" (o id só quando falta o
   data-tri, como na B). Entrada nova na página começa em 0: no carregamento, UMA vez, as posições velhas da página (de qualquer trilho dela, e só
   dela) são esquecidas; depois disso todo trilho que nasce com posição guardada a recebe, inclusive os redesenhados na mesma visita (troca de aba:
   rolar On, ir para Wilson e voltar para On devolve o 6º card). Voltar (botão voltar, recarregar, ou a página que volta do cache de ida e volta, no
   evento pageshow) devolve a posição. ITEM ATIVO À VISTA: trilho visível que tem um [aria-current] (a árvore de tipos da coleção, em que cada
   troca de subcategoria é uma navegação nova) rola de lado até ele ficar à vista, centrado quando dá: sem posição guardada, no lugar dela; com
   posição guardada, depois de devolvê-la, se o item ficou fora (a chave é só o caminho, então voltar de Corrida para Infantil traz a posição
   gravada na página de Corrida). Só o scrollLeft do próprio trilho muda (nada de scrollIntoView, que também rolaria a página na vertical) e
   sem animação. A rolagem é gravada 150 ms depois da última (debounce; trilho que já saiu do DOM não grava), e na hora em
   que a página sai de vista (pagehide, visibilitychange para hidden). Trilho que nasce oculto (mede 0) guarda a posição e a recebe quando
   ganhar tamanho (ResizeObserver). sessionStorage pode estar bloqueado ou cheio (navegação privada, política do navegador): toda leitura e
   escrita está em try/catch, e sem ele o trilho continua rolando, só não lembra.

   SEM LAYOUT FORÇADO. Cada atualização LÊ tudo (scrollWidth, clientWidth, scrollLeft) e só depois ESCREVE; a sincronização lê todos os
   trilhos antes de escrever em qualquer um. As setas e a régua de cada trilho ficam em cache (nada de consulta ao documento a cada rolagem).
   Mudar a largura da janela é um trabalho só: o ResizeObserver mede de novo o trilho que mudou de tamanho e a media query dos 900px refaz a régua.
   O evento resize só trabalha onde não há ResizeObserver (120 ms de espera; sai se a largura não mudou, como a barra de endereço do celular).
   Carregar o arquivo duas vezes não faz nada na segunda.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || window.HitTrilhos) return;

  const DESK = window.matchMedia('(min-width:900px)'), REDUZ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));
  const esc = (window.CSS && window.CSS.escape) || ((s) => String(s).replace(/["\\]/g, '\\$&'));
  const PREFIXO = 'hit:tri:';
  const ESPERA_GRAVAR = 150, ESPERA_RESIZE = 120; // ms

  /* ---------- posição guardada ---------- */
  const chaveDe = (t) => PREFIXO + location.pathname + '|' + (t.dataset.tri || t.id);
  function le(t) {
    try { const v = parseFloat(window.sessionStorage.getItem(chaveDe(t))); return v > 0 ? v : 0; } catch (e) { return 0; }
  }
  function guarda(t) {
    try { window.sessionStorage.setItem(chaveDe(t), String(Math.round(t.scrollLeft))); } catch (e) { /* bloqueado ou cheio: segue sem lembrar */ }
  }
  function esquece(t) {
    try { window.sessionStorage.removeItem(chaveDe(t)); } catch (e) { /* idem */ }
  }
  /* entrada nova: apaga as posições desta página (todas as chaves "hit:tri:<caminho>|…"), de trilho que exista ou não, e nenhuma de outra página */
  function esqueceDaPagina() {
    try {
      const ss = window.sessionStorage, prefixo = PREFIXO + location.pathname + '|', velhas = [];
      for (let i = 0; i < ss.length; i += 1) { const k = ss.key(i); if (k && k.indexOf(prefixo) === 0) velhas.push(k); }
      velhas.forEach((k) => ss.removeItem(k));
    } catch (e) { /* sem sessionStorage: não há o que esquecer */ }
  }

  /* ---------- setas e régua: o que cada trilho carrega fica em cache ---------- */
  let cache = new WeakMap(); // trilho -> [{ g, a, b }]: o par de setas (grupo, anterior, próximo); zera quando entram setas novas
  function setasDe(t) {
    let lista = cache.get(t);
    if (!lista || lista.some((s) => !s.g.isConnected)) {
      lista = $$('.setas[data-sd="' + esc(t.id) + '"]').map((g) => { const par = $$('.seta', g); return { g, a: par[0], b: par[1] }; });
      cache.set(t, lista);
    }
    return lista;
  }
  const reguaDe = (t) => (t.nextElementSibling && t.nextElementSibling.classList.contains('regua') ? t.nextElementSibling : null);

  /* mede: só LEITURA do layout, tudo de uma vez */
  function mede(t) {
    const larg = t.clientWidth, total = t.scrollWidth, esq = t.scrollLeft, max = total - larg;
    return { t, larg, total, esq, max, rola: max > 2 };
  }
  /* aplica: só ESCRITA, com o que mede() trouxe (e a última largura vista, para o ResizeObserver) */
  const ultimaLargura = new WeakMap();
  function aplica(m) {
    const { t, larg, total, esq, max, rola } = m;
    ultimaLargura.set(t, larg);
    if (rola) t.setAttribute('tabindex', '0'); else t.removeAttribute('tabindex');
    const rg = reguaDe(t);
    if (rg) {
      rg.hidden = !rola;
      if (rola) {
        const fracao = larg / total, i = rg.firstElementChild;
        i.style.width = (fracao * 100) + '%';
        i.style.left = ((max > 0 ? esq / max : 0) * (1 - fracao) * 100) + '%';
      }
    }
    setasDe(t).forEach(({ g, a, b }) => {
      g.hidden = !rola;
      if (a) a.setAttribute('aria-disabled', String(esq <= 2));
      if (b) b.setAttribute('aria-disabled', String(esq >= max - 2));
    });
  }
  function atualizaTrilho(t) {
    if (t) aplica(mede(t));
  }

  /* a régua só existe abaixo de 900; ao mudar de largura ela entra ou sai. Lê todos os trilhos, depois escreve em todos */
  let larguraVista = -1;
  function sincronizaTrilhos() {
    larguraVista = window.innerWidth;
    const desk = DESK.matches, trilhos = $$('[data-rol]');
    const medidas = trilhos.map(mede);
    trilhos.forEach((t) => {
      const rg = reguaDe(t);
      if (desk && rg) rg.remove();
      if (!desk && !rg) t.insertAdjacentHTML('afterend', '<div class="regua" aria-hidden="true" hidden><i></i></div>');
    });
    medidas.forEach(aplica);
  }
  /* com encaixe obrigatório, mudar scrollLeft por script volta na hora: desliga o encaixe, aplica e religa */
  function restauraTri(t, v) {
    t.style.scrollSnapType = 'none';
    t.scrollLeft = v;
    window.requestAnimationFrame(() => { t.style.scrollSnapType = ''; atualizaTrilho(t); });
  }
  function rolaSeta(b) {
    const t = document.getElementById(b.getAttribute('aria-controls'));
    if (!t) return;
    const w = t.firstElementChild ? t.firstElementChild.getBoundingClientRect().width : 0;
    t.scrollBy({ left: parseInt(b.dataset.d, 10) * (t.clientWidth - w), behavior: REDUZ.matches ? 'auto' : 'smooth' });
  }

  /* ---------- volta à posição ---------- */
  function tipoDaNavegacao() {
    try { const e = window.performance.getEntriesByType('navigation')[0]; return e ? e.type : 'navigate'; } catch (e) { return 'navigate'; }
  }
  const voltando = ['back_forward', 'reload'].indexOf(tipoDaNavegacao()) >= 0; // só o inicia() lê: decide se esquece as posições velhas
  const vistos = new WeakSet();
  const esperando = new WeakSet(); // tem posição para receber, mas nasceu oculto (mede 0): espera ganhar tamanho

  /* trilho que muda de tamanho (inclusive o que sai do oculto) se mede de novo; o que esperava a posição guardada a recebe agora */
  function aoMudarDeTamanho(entradas) {
    const medidas = entradas.map((e) => mede(e.target));
    medidas.forEach((m) => {
      const t = m.t;
      if (esperando.has(t) && m.larg > 0) {
        esperando.delete(t);
        const v = le(t);
        if (v > 0) { restauraTri(t, v); ativoAVista([t]); return; }
      }
      if (t.hasAttribute('data-rol') && ultimaLargura.get(t) !== m.larg) aplica(m);
    });
  }
  const observador = window.ResizeObserver ? new window.ResizeObserver(aoMudarDeTamanho) : null;

  /* item ativo à vista (LEITURA): o scrollLeft que centra o [aria-current] do trilho, ou -1 quando não há item ativo ou ele já está à vista */
  function guardada(t) {
    try { return window.sessionStorage.getItem(chaveDe(t)) !== null; } catch (e) { return false; }
  }
  function alvoDoAtual(t) {
    const a = t.querySelector('[aria-current]');
    if (!a) return -1;
    const rt = t.getBoundingClientRect(), ra = a.getBoundingClientRect();
    if (ra.left >= rt.left && ra.right <= rt.right) return -1;
    return Math.max(0, Math.round(t.scrollLeft + (ra.left + ra.width / 2) - (rt.left + rt.width / 2)));
  }

  /* depois de devolver posições guardadas (ESCRITA), o item ativo que ficou fora vem à vista: lê todos, depois escreve. Só o trilho com
     [aria-current] lê o layout de novo */
  function ativoAVista(trilhos) {
    const alvos = trilhos.map(alvoDoAtual);
    trilhos.forEach((t, i) => {
      if (alvos[i] < 0) return;
      if (t.hasAttribute('data-rol')) restauraTri(t, alvos[i]); else t.scrollLeft = alvos[i];
    });
  }

  function adota(t, visivel, alvo) {
    vistos.add(t);
    if (observador) observador.observe(t);
    const v = le(t);
    if (v <= 0) {
      // sem posição para devolver: o item ativo à vista (o trilho com encaixe passa pelo restauraTri, que desliga o encaixe para aplicar)
      if (alvo >= 0) { if (t.hasAttribute('data-rol')) restauraTri(t, alvo); else t.scrollLeft = alvo; }
      return;
    }
    if (visivel) restauraTri(t, v); else esperando.add(t);
  }
  function adotaTodos(forca) {
    const novos = $$('[data-tri]').filter((t) => forca || !vistos.has(t));
    const visiveis = novos.map((t) => t.clientWidth > 0); // lê tudo antes de restaurar qualquer um
    const alvos = novos.map((t, i) => (visiveis[i] && !guardada(t) ? alvoDoAtual(t) : -1));
    novos.forEach((t, i) => adota(t, visiveis[i], alvos[i]));
    ativoAVista(novos.filter((t, i) => visiveis[i] && guardada(t))); // com posição guardada (mesmo 0): o adota a devolveu, o ativo pode ter ficado fora
    sincronizaTrilhos();
  }

  /* a rolagem é gravada 150 ms depois da última (debounce); ao sair de vista, na hora */
  const pendentes = new Set();
  let esperaGravar = 0;
  function descarrega() {
    clearTimeout(esperaGravar);
    esperaGravar = 0;
    pendentes.forEach((t) => { if (t.isConnected) guarda(t); }); // trilho que saiu do DOM mede 0: gravar apagaria a posição guardada
    pendentes.clear();
  }
  function registraRolagem(ev) {
    const t = ev.target;
    if (!t || !t.dataset || !t.dataset.tri) return;
    pendentes.add(t);
    clearTimeout(esperaGravar);
    esperaGravar = setTimeout(descarrega, ESPERA_GRAVAR);
    if (t.hasAttribute('data-rol')) atualizaTrilho(t);
  }
  /* saiu de vista (pagehide, ou a aba foi para o fundo, que no celular pode ser o último aviso): grava todos, menos os que ainda esperam a posição */
  function saiuDeVista() {
    descarrega();
    $$('[data-tri]').filter((t) => !esperando.has(t)).forEach(guarda);
  }

  /* trilhos e setas que nascem depois (blocos que o JS desenha): entram na mesma regra, e o cache das setas recomeça */
  function observaNovos() {
    if (!window.MutationObserver || !document.body) return;
    const NOVO = '[data-tri], .setas';
    let agendado = 0;
    new window.MutationObserver((lista) => {
      const novo = lista.some((m) => Array.prototype.some.call(m.addedNodes, (n) => n.nodeType === 1 && (n.matches(NOVO) || n.querySelector(NOVO))));
      if (!novo || agendado) return;
      agendado = window.requestAnimationFrame(() => { agendado = 0; cache = new WeakMap(); adotaTodos(false); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function inicia() {
    document.addEventListener('scroll', registraRolagem, { capture: true, passive: true });
    document.addEventListener('click', (ev) => {
      const b = ev.target.closest && ev.target.closest('[data-act="seta"]');
      if (b) rolaSeta(b);
    });
    /* com ResizeObserver o resize é redundante (o observador mede o trilho que mudou, e a media query dos 900px refaz a régua) */
    if (!observador) {
      let rt;
      window.addEventListener('resize', () => {
        clearTimeout(rt);
        rt = setTimeout(() => { if (window.innerWidth !== larguraVista) sincronizaTrilhos(); }, ESPERA_RESIZE);
      });
    }
    if (DESK.addEventListener) DESK.addEventListener('change', sincronizaTrilhos); // já deixa a largura vista: o resize que vem junto sai sem fazer nada
    /* pageshow de carga (persisted false) não faz nada: o inicia() já adotou. Do cache de ida e volta (persisted true), a posição volta */
    window.addEventListener('pageshow', (ev) => { if (ev.persisted) adotaTodos(true); });
    window.addEventListener('pagehide', saiuDeVista);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') saiuDeVista(); });
    if (!voltando) esqueceDaPagina();
    adotaTodos(false);
    observaNovos();
  }

  window.HitTrilhos = Object.freeze({ atualizaTrilho, sincronizaTrilhos, restauraTri, rolaSeta, posicao: Object.freeze({ le, guarda, esquece }) });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia); else inicia();
})();
